import React from 'react'
import { Link } from 'react-router-dom'

function TeamSquadListTemplate({player}) {
    return (
        <div style={{fontSize: "13px"}} className="row bg-white z-depth-1 p-3" key={player.player_id}>
            <div className="col-4 col-xl-7">
                <Link to={`/players-api/${player.player_id}`}>{player.player_name}</Link> 
            </div>
            
            <div className="col-2 col-xl-1">
                {player.age}
            </div>
            <div className="col-2">
                {player.nationality}
            </div>
            <div className="col-2">
                <span className="text-right">{player.position} </span>
            </div>
        </div>
    )
}
export default TeamSquadListTemplate